import React, { useEffect, useRef } from 'react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import './tabs.css';
import UsersOrders2 from '../tables/users_orders';
import UsersTrades2 from '../tables/users_trades';
import Users2 from '../tables/users';
import Firms from '../tables/firms';
import TradingAccounts2 from '../tables/trading_accounts';
import Holdings2 from '../tables/holdings';
import { useSelector } from 'react-redux';
import { selectIsMarketController } from '../../redux/globalsSlice';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/panelPositionsSlice';

export const UserDataTabs = () => {
    const isMarketController = useSelector(selectIsMarketController);
    const isMarketControllerRef = useRef(isMarketController);
    const dispatch = useDispatch();
    const userId = useSelector(state => state.globals.tsUserId);
    const tabCount = isMarketControllerRef.current ? 6 : 4;

    const savedTab = useSelector(state =>
        state.panelPositions.panelLayouts?.[userId]?.['UserDataTabs']?.activeTab
    );

    const safeIndex = savedTab !== undefined && savedTab < tabCount ? savedTab: 0;
    
    useEffect(() => {
        isMarketControllerRef.current = isMarketController;
    }, [isMarketController]);

    return (
        <div className="data-tabs">
            <Tabs
            key={`${userId}-${tabCount}`}   // 👈 forces remount when structure changes
            forceRenderTabPanel={true}
            className="Tabs"
            selectedIndex={safeIndex}
            onSelect={(index) => {
                dispatch(setActiveTab({
                userId,
                panelId: 'UserDataTabs',
                tabId: index
                }));
            }}
            >
                <TabList>
                    <Tab>Orders</Tab>
                    <Tab>Trades</Tab>
                    {isMarketControllerRef.current && <Tab>Users</Tab>}
                    {isMarketControllerRef.current && <Tab>Firms</Tab>}
                    <Tab>Trading Accounts</Tab>
                    <Tab>Holdings</Tab>
                </TabList>

                <TabPanel>
                    <UsersOrders2 />
                </TabPanel>
                <TabPanel>
                    <UsersTrades2 />
                </TabPanel>
                {isMarketControllerRef.current && (
                    <TabPanel>
                        <Users2 />
                    </TabPanel>
                )}
                {isMarketControllerRef.current && (
                    <TabPanel>
                        <Firms />
                    </TabPanel>
                )}
                <TabPanel>
                    <TradingAccounts2 />
                </TabPanel>
                <TabPanel>
                    <Holdings2 />
                </TabPanel>
            </Tabs>
        </div>
    );
}
